import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 25,
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18
  },
  subtitle: {
    fontWeight: 'bold',
    fontSize: 16
  },
  text: {
    fontWeight: 'normal',
    fontSize: 16
  }

});
